import { Link } from 'react-router-dom';
import { type BreadcrumbSegment, buildScopePath, ROOT_NODE } from '../lib/hierarchy-route';

export type { BreadcrumbSegment };

export interface HierarchyBreadcrumbProps {
  path: BreadcrumbSegment[];
}

const linkStyle = { color: 'var(--genai-sem-accent)', textDecoration: 'none' };

/**
 * FR-3: the page-header breadcrumb. Renders the URL-derived scope chain (root → node,
 * plus the leaf entity) as the ambient "where am I" display and up-navigation. Each
 * ancestor is a typed-route link (AC-3.2 via {@link buildScopePath}); the last segment
 * is the current location and renders as plain text. A "CAPTG" root anchor
 * (links to `/`, the future company-overview home) precedes the chain.
 */
export function HierarchyBreadcrumb({ path }: HierarchyBreadcrumbProps) {
  if (path.length === 0) return null;

  return (
    <nav className="text-base text-muted mb-md" data-testid="hierarchy-breadcrumb">
      <Link to="/" style={linkStyle}>
        {ROOT_NODE.name}
      </Link>
      {path.map((segment, index) => {
        const isLast = index === path.length - 1;
        return (
          <span key={segment.number}>
            {' / '}
            {isLast ? (
              <span>{segment.name}</span>
            ) : (
              <Link to={buildScopePath({ tier: segment.tier, number: segment.number })} style={linkStyle}>
                {segment.name}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
